// Copied with modifications from `app/view/static/js/candidate/_notifications.js`.
let $notificationTemplate;
let $notificationCount;
let $notificationList;
let unreadCount = 0;
let notificationsLoaded = false;

const markNotificationsAsSeen = () => {
  $.log_event('notification_bell_click', { 'new-item-present': unreadCount || 'None' });

  if (unreadCount > 0) {
    $.ajax({
      url: '/notifier/notification/markallread',
      method: 'POST',
    });
    unreadCount = 0;
  }
};

const updateUnreadCount = () => {
  if (unreadCount === 0) {
    $notificationCount.removeClass('num_loaded');
  } else {
    $notificationCount.addClass('num_loaded');
  }

  $notificationCount.html(unreadCount);
};

const addNotification = (notification) => {
  let summary = `${notification.job_title}, ${notification.hiring_company_name}`;
  let title;
  let prompt;
  let link;

  if (zr && zr.page && zr.page.model && zr.page.model.show_references) {
    prompt = 'Add a Reference';
    link = '/profile/request/reference';
  } else {
    prompt = 'View My Profile';
    link = '/candidate/about';
  }

  if (notification.notification_type === 'application_viewed') {
    title = 'Application viewed!';
  } else if (notification.notification_type === 'resume_thumbs_up') {
    title = 'You were given a thumbs up!';
  } else if (notification.notification_type === 'no notifications') {
    title = 'You are up to date';
    if (window.location.href.split('/').pop() !== 'suggested-jobs') {
      prompt = 'View Suggested Jobs';
      link = '/candidate/suggested-jobs';
    }
    summary = 'Check back later!';
  }

  if (notification.unread) {
    unreadCount += 1;
  }

  const $newNotification = $notificationTemplate.clone();

  $newNotification.addClass(notification.unread ? 'unread' : '');
  $newNotification.find('.title').text(title);
  $newNotification.find('.summary').text(summary);
  $newNotification.find('.summary a').text(notification.quiz_url);
  $newNotification.find('.prompt').text(prompt).attr('href', link);
  $newNotification.show();

  $notificationList.append($newNotification);
};

const displayNotifications = (resp) => {
  const notifications = resp?.data?.notifications || [];

  $(document).one('click', '[data-notification-type]', markNotificationsAsSeen);
  $('[data-notification-loading]').hide();

  unreadCount = notifications.length;

  if (unreadCount === 0) {
    notifications.push({
      notification_type: 'no notifications',
    });
  }

  notifications.forEach(addNotification);

  updateUnreadCount();
};

const loadNotifications = async () => {
  if (notificationsLoaded) {
    return;
  }

  notificationsLoaded = true;

  $('[data-notification-loading]').show();

  // await new Promise((res) => { setTimeout(() => { res(); }, 1000); });
  // displayNotifications({
  //   data: {
  //     notifications: [{
  //       job_title: 'Job Title',
  //       hiring_company_name: 'Hiring Company',
  //       notification_type: 'application_viewed',
  //       quiz_url: 'url',
  //       unread: true,
  //     },
  //     {
  //       job_title: 'Job Title',
  //       hiring_company_name: 'Hiring Company',
  //       notification_type: 'application_viewed',
  //       quiz_url: 'url',
  //       unread: true,
  //     }],
  //   },
  // });
  // return;

  $.ajax({
    url: '/notifier/headlines',
    cache: false,
  })
    .done(displayNotifications)
    .fail(() => { $('[data-notification-loading] div').html('An error has occurred. Please try again later.'); });
};

export const initNotifications = () => {
  $notificationTemplate = $('[data-notification-template]');
  $notificationCount = $('[data-notification-count]');
  $notificationList = $('[data-notification-list]');

  loadNotifications();
};

export default initNotifications;
